// Builds the orders-list API params from the route search params. Shared by the
// table controller and the route loader so prefetch + render produce the same
// query key (one cache entry, no double fetch).

import { DEFAULT_SORT_BY, DEFAULT_SORT_ORDER } from '../-constants';
import type { IOrdersListParams, OrderQuickFilter } from '../-types';

// Matches useTable's default page size.
const DEFAULT_LIMIT = 50;

export interface ListSearch {
  page?: number;
  limit?: number;
  sort?: string;
  filters?: Record<string, string[]>;
  quickFilter?: OrderQuickFilter;
  unmapped?: boolean;
}

export function buildOrdersListParams(search: ListSearch): IOrdersListParams {
  let sortBy = DEFAULT_SORT_BY;
  let sortOrder: 'asc' | 'desc' = DEFAULT_SORT_ORDER;
  if (search.sort) {
    const [field, dir] = search.sort.split(':');
    if (field) {
      sortBy = field;
      sortOrder = dir === 'DESC' ? 'desc' : 'asc';
    }
  }
  return {
    page: search.page ?? 1,
    limit: search.limit ?? DEFAULT_LIMIT,
    sortBy,
    sortOrder,
    quickFilter: search.quickFilter ?? 'all',
    filter: search.filters ?? {},
    // Omit the key entirely when off (exactOptionalPropertyTypes: no explicit
    // `undefined` on an optional field).
    ...(search.unmapped ? { unmapped: true } : {}),
  };
}
